import auditLog from './audit_log';
import builder from './builder';
import config from './config';
import devices from './devices';
import filter from './filter';
import gapi from './gapi';
import pipelines from './pipelines';
import result from './result';
import session from './session';
import ui from './ui';
import user from './user';
import users from './users';

export default {
  auditLog,
  builder,
  config,
  devices,
  filter,
  gapi,
  pipelines,
  result,
  session,
  ui,
  user,
  users,
}
